import { useFormik } from 'formik';

const useForm = ({
  initialValues,
  onSubmit,
  validationSchema,
  validate,
  enableReinitialize = false,
  validateOnMount = false,
}) => {
  const {
    handleChange,
    handleSubmit,
    handleBlur,
    setFieldValue,
    setValues,
    values,
    touched,
    errors,
    isValid,
    dirty,
    resetForm,
    validateForm,
    setFieldError,
    validateField,
    setFieldTouched,
  } = useFormik({
    initialValues,
    validationSchema,
    validate,
    onSubmit,
    enableReinitialize,
    validateOnMount,
  });

  const inputError = name => touched[name] && errors[name];
  const disabledSubmit = !isValid || !dirty;

  return {
    handleChange,
    handleBlur,
    handleSubmit,
    values,
    inputError,
    disabledSubmit,
    setFieldValue,
    setValues,
    resetForm,
    isValid,
    validateForm,
    setFieldError,
    dirty,
    validateField,
    errors,
    setFieldTouched,
  };
};

export default useForm;
